import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import {
  ButtonModule,
  DIALOG_DATA,
  DialogModule,
  DialogRef,
  DialogService,
} from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

export type ImportWarningDialogData = {
  organizationName: string;
};

@Component({
  templateUrl: "./import-warning-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogModule, ButtonModule, I18nPipe],
})
export class ImportWarningDialogComponent {
  protected readonly warningMessage: string;

  constructor(
    private readonly dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) data: ImportWarningDialogData,
    i18nService: I18nService,
  ) {
    this.warningMessage = i18nService.t("importWarning", data.organizationName);
  }

  protected close(result: boolean): void {
    void this.dialogRef.close(result);
  }

  static open(dialogService: DialogService, organizationName: string): Promise<boolean> {
    const dialogRef = dialogService.open<boolean>(ImportWarningDialogComponent, {
      data: { organizationName },
    });
    return firstValueFrom(dialogRef.closed).then((result) => result ?? false);
  }
}
